export const DEFAULT_TITLE = 'Incredible Prices, Monthly Subscription';
export const DEFAULT_CTA_TEXT = 'Check Our prices';
export const DEFAULT_CTA_TEXT_MOBILE = 'Check prices';
import carDesktop from '@/static/assets/products/car_desktop.svg';
import carMobile from '@/static/assets/products/car_mobile.svg';
import hoDesktop from '@/static/assets/products/homeowners_desktop.svg';
import hoMobile from '@/static/assets/products/homeowners_mobile.svg';
import lifeDesktop from '@/static/assets/products/life_desktop.svg';
import lifeMobile from '@/static/assets/products/life_mobile.svg';
import petDesktop from '@/static/assets/products/pet_desktop.svg';
import petMobile from '@/static/assets/products/pet_mobile.svg';
import rentersDesktop from '@/static/assets/products/renters_desktop.svg';
import rentersMobile from '@/static/assets/products/renters_mobile.svg';
// EU
import hoMobile_eu from '@/static/assets/products/homeowners_eu_mobile.svg';
import hoDesktop_eu from '@/static/assets/products/homepage_eu_desktop.svg';
import landlordDesktop_eu from '@/static/assets/products/landlords_eu_desktop.svg';
import landlordMobile_eu from '@/static/assets/products/landlords_eu_mobile.svg';
// UK
import buildingsContentsDesktop from '@/static/assets/uk_homepage/products/buildings-contents-desktop.svg';
import buildingsContentsMobile from '@/static/assets/uk_homepage/products/buildings-contents-mobile.svg';
import buildingsDesktop from '@/static/assets/uk_homepage/products/buildings-desktop.svg';
import buildingsMobile from '@/static/assets/uk_homepage/products/buildings-mobile.svg';
import contentsDesktop from '@/static/assets/uk_homepage/products/contents-desktop.svg';
import contentsMobile from '@/static/assets/uk_homepage/products/contents-mobile.svg';

export type ProductType =
  | 'car'
  | 'home_us_owners'
  | 'home_us_renters'
  | 'life'
  | 'pet'
  | 'home_eu_owners'
  | 'home_eu_renters'
  | 'landlords_eu'
  | 'home_uk_contents'
  | 'home_uk_buildings'
  | 'home_uk_buildings_contents';

const SOURCE: Record<ProductType, string> = {
  car: 'car',
  home_us_owners: 'owner',
  home_eu_owners: 'owner_eu',
  home_us_renters: 'renter',
  home_eu_renters: 'renter_eu',
  landlords_eu: 'landlord_eu',
  life: 'life',
  pet: 'pet',
  home_uk_contents: 'uk_contents',
  home_uk_buildings: 'uk_buildings',
  home_uk_buildings_contents: 'uk_buildings_contents',
};

const GTM_ID: Record<ProductType, string> = {
  car: 'gtm_button_get_car',
  home_us_owners: 'gtm_button_get_general_homeowners',
  home_eu_owners: 'gtm_button_get_general_homeowners',
  home_us_renters: 'gtm_button_get_renters',
  home_eu_renters: 'gtm_button_get_renters',
  life: 'gtm_button_get_life',
  pet: 'gtm_button_get_pet',
  landlords_eu: 'gtm_button_get_landlords',
  home_uk_contents: 'gtm_button_get_uk_contents',
  home_uk_buildings: 'gtm_button_get_uk_buildings',
  home_uk_buildings_contents: 'gtm_button_get_uk_buildings_contents',
};

const IMAGES_DESKTOP: Record<ProductType, string | StaticImageData> = {
  car: carDesktop,
  home_us_owners: hoDesktop,
  home_eu_owners: hoDesktop_eu,
  home_us_renters: rentersDesktop,
  home_eu_renters: rentersDesktop,
  life: lifeDesktop,
  pet: petDesktop,
  landlords_eu: landlordDesktop_eu,
  home_uk_contents: contentsDesktop,
  home_uk_buildings: buildingsDesktop,
  home_uk_buildings_contents: buildingsContentsDesktop,
};

const IMAGES_MOBILE: Record<ProductType, string | StaticImageData> = {
  car: carMobile,
  home_us_owners: hoMobile,
  home_eu_owners: hoMobile_eu,
  home_us_renters: rentersMobile,
  home_eu_renters: rentersMobile,
  life: lifeMobile,
  pet: petMobile,
  landlords_eu: landlordMobile_eu,
  home_uk_contents: contentsMobile,
  home_uk_buildings: buildingsMobile,
  home_uk_buildings_contents: buildingsContentsMobile,
};

export const DYNAMIC_PRODUCT_PROPERTIES = {
  source: SOURCE,
  gtmId: GTM_ID,
  imageDesktop: IMAGES_DESKTOP,
  imageMobile: IMAGES_MOBILE,
};

export interface Product {
  readonly title: string;
  readonly subtitle: string;
  readonly price: string;
  readonly product: ProductType;
  readonly ctaLabelDesktop: string;
  readonly ctaLabelMobile: string;
  readonly customUrl?: string;
  readonly alt?: string;
}

export const DEFAULT_SECTION_TITLE = 'Incredible Prices, Monthly Subscription';
export const DEFAULT_SECTION_SUBTITLE = 'Amazing savings when you bundle';
export const CUSTOM_URL = '/onboarding/start?p=';

export const DEFAULT_PRODUCTS = [
  {
    title: 'Renters',
    subtitle: 'Coverage for your stuff, in and out of your home',
    price: 'From $5/mo',
    product: 'home_us_renters',
    ctaLabelDesktop: 'Check Our Prices',
    ctaLabelMobile: 'Our Prices',
  },
  {
    title: 'Homeowners',
    subtitle: 'Protection for your home and stuff',
    price: 'From $25/mo',
    product: 'home_us_owners',
    ctaLabelDesktop: 'Check Our Prices',
    ctaLabelMobile: 'Our Prices',
  },
  {
    title: 'Car',
    subtitle: 'Protect your car, passengers, and the planet',
    price: 'As low as $30/mo',
    product: 'car',
    ctaLabelDesktop: 'Check Our Prices',
    ctaLabelMobile: 'Our Prices',
  },
  {
    title: 'Term Life',
    subtitle: 'Protecting the people you love',
    price: 'From $9/mo',
    product: 'life',
    ctaLabelDesktop: 'Check Our Prices',
    ctaLabelMobile: 'Our Prices',
  },
  {
    title: 'Pet',
    subtitle: 'Health insurance for furry family members',
    price: 'From $10/mo',
    product: 'pet',
    ctaLabelDesktop: 'Check Our Prices',
    ctaLabelMobile: 'Our Prices',
  },
] as Product[];
